/**
 * HOOK: useVehiclesSelect
 * Hook léger pour charger uniquement les véhicules nécessaires aux selects
 *
 * ⚡ Optimisation: Ne charge que id + registration
 */

import { useSelectData } from './useSelectData';

interface VehicleSelectItem {
  id: string;
  registration: string;
}

interface UseVehiclesSelectReturn {
  vehicles: VehicleSelectItem[];
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

export function useVehiclesSelect(): UseVehiclesSelectReturn {
  const { data, loading, error, refresh } = useSelectData(
    'vehicles',
    'id, registration',
    'registration',
    true
  );

  return {
    vehicles: data as VehicleSelectItem[],
    loading,
    error,
    refresh,
  };
}
